import * as React from "react";
import NavBar from "@acto/react-navbar";

class NavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.triggerToggleHamburger = this.triggerToggleHamburger.bind(this);
    this.state = {
      rightLinks: (
        <>
          <a href="#about" onClick={this.triggerToggleHamburger}>
            ABOUT
          </a>
          <a href="#experience" onClick={this.triggerToggleHamburger}>
            EXPERIENCE
          </a>
          <a href="#academics" onClick={this.triggerToggleHamburger}>
            ACADEMICS
          </a>
          <a href="#abilities" onClick={this.triggerToggleHamburger}>
            ABILITIES
          </a>
          <a href="#contact" onClick={this.triggerToggleHamburger}>
            CONTACT
          </a>
        </>
      ),
      navTheme: {
        mainColor: "#103850",
        menuBgColor: "#103850",
        backgroundColor: "#fff",
      },
      navBrand: (
        <a href="/">
          <img src="/intro-image.jpg" alt="I like to stay awesome always!" />
          <span className="site-name-brand">sunil sivadas</span>
        </a>
      ),
    };
  }

  triggerToggleHamburger() {
    if (window.screen.width <= 768) {
      document.getElementsByClassName("burger")[0].click();
    }
  }

  render() {
    return (
      <NavBar
        className="navbar"
        menuClassName="navbar--menu"
        brand={this.state.navBrand}
        theme={this.state.navTheme}
        rightLinks={this.state.rightLinks}
        shouldHideOnScroll={false}
      />
    );
  }
}

export default NavigationBar;
